import EventsHandler from './events-handler'

class EventsFormHandler extends EventsHandler {
    constructor () {
        super('form[data-dl-event]', 'submit')
    }

    prepareArgs (args, el) {
        if (args.formKeysMap) {
            const formData = new FormData(el)
            for (const keyval of formData.entries()) {
                if (args.formKeysMap[keyval[0]]) {
                    args[args.formKeysMap[keyval[0]]] = keyval[1]
                }
            }
            delete args.formKeysMap
        }
        return args
    }
}

export default EventsFormHandler